import { render, staticRenderFns } from "./AffiliatesMiniCard.vue?vue&type=template&id=72bc79fb&"
import script from "./AffiliatesMiniCard.vue?vue&type=script&lang=js&"
export * from "./AffiliatesMiniCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports